import { render, staticRenderFns } from "./ArmariosView.vue?vue&type=template&id=6f76a27a&scoped=true"
import script from "./ArmariosView.vue?vue&type=script&lang=js"
export * from "./ArmariosView.vue?vue&type=script&lang=js"
import style0 from "./ArmariosView.vue?vue&type=style&index=0&id=6f76a27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f76a27a",
  null
  
)

export default component.exports